export default {"src":"/_next/static/media/excalidraw.449162cc.svg","height":43,"width":137};